var $cJ6Zc$lodash = require("lodash");
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function (key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }
    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });
  return dest;
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
var $2b426f67b59e8726$exports = {};
$parcel$export($2b426f67b59e8726$exports, "formatBytes", function () {
  return $2b426f67b59e8726$export$e1a3971de07c83b5;
});
var $b7f4fcabf3442813$exports = {};
$parcel$export($b7f4fcabf3442813$exports, "roundToPlaces", function () {
  return $b7f4fcabf3442813$export$e5391d7b13fe3535;
});
function $b7f4fcabf3442813$export$e5391d7b13fe3535(number, places) {
  var multiplier = Math.pow(10, places);
  return Math.round(number * multiplier) / multiplier;
}
var $ac7bd25d01e28e2d$exports = {};
$parcel$export($ac7bd25d01e28e2d$exports, "isNumber", function () {
  return $ac7bd25d01e28e2d$export$7e4aa119212bc614;
});
var $ac7bd25d01e28e2d$export$7e4aa119212bc614 = function $ac7bd25d01e28e2d$export$7e4aa119212bc614(value) {
  return isNaN(parseFloat(value)) === false || isFinite(value) === true;
};
var $2b426f67b59e8726$export$e1a3971de07c83b5 = $parcel$interopDefault($cJ6Zc$lodash).memoize(function (value) {
  if (!$ac7bd25d01e28e2d$export$7e4aa119212bc614(value)) return value;
  // Default case is Bytes
  var formatted = value;
  var suffix = 'B';
  var formatters = {
    PB: Math.pow(2, 50),
    TB: Math.pow(2, 40),
    GB: Math.pow(2, 30),
    MB: Math.pow(2, 20),
    KB: Math.pow(2, 10)
  };
  $parcel$interopDefault($cJ6Zc$lodash).forEach(formatters, function (unit, key) {
    if (value >= unit) {
      suffix = key;
      formatted = value / unit;
      return false;
    }
  });
  return "".concat($b7f4fcabf3442813$export$e5391d7b13fe3535(formatted, 2).toLocaleString(undefined, {
    maximumSignificantDigits: 4
  })).concat(suffix);
});
var $c66c7baffc1c0dfc$exports = {};
$parcel$export($c66c7baffc1c0dfc$exports, "formatMilliseconds", function () {
  return $c66c7baffc1c0dfc$export$5daf09ba04077ce8;
});
var $c66c7baffc1c0dfc$export$5daf09ba04077ce8 = $parcel$interopDefault($cJ6Zc$lodash).memoize(function (value) {
  if (!$ac7bd25d01e28e2d$export$7e4aa119212bc614(value)) return value;
  // Default case is milliseconds
  var formatted = value;
  var suffix = 'ms';
  var formatters = {
    h: 3600000,
    m: 60000,
    s: 1000
  };
  $parcel$interopDefault($cJ6Zc$lodash).forEach(formatters, function (unit, key) {
    if (value >= unit) {
      suffix = key;
      formatted = value / unit;
      return false;
    }
  });
  return "".concat($b7f4fcabf3442813$export$e5391d7b13fe3535(formatted, 2).toLocaleString()).concat(suffix);
});
var $2cb2128e0b9e1f2c$exports = {};
$parcel$export($2cb2128e0b9e1f2c$exports, "formatNumber", function () {
  return $2cb2128e0b9e1f2c$export$f5dd818bff069720;
});
var $2cb2128e0b9e1f2c$export$f5dd818bff069720 = $parcel$interopDefault($cJ6Zc$lodash).memoize(function (value) {
  if (!$ac7bd25d01e28e2d$export$7e4aa119212bc614(value)) return value;
  // No suffix for default case
  var formatted = value;
  var suffix = '';
  var formatters = {
    B: Math.pow(10, 9),
    M: Math.pow(10, 6),
    K: 1000
  };
  $parcel$interopDefault($cJ6Zc$lodash).forEach(formatters, function (unit, key) {
    if (value >= unit) {
      suffix = key;
      formatted = value / unit;
      return false;
    }
  });
  return "".concat($b7f4fcabf3442813$export$e5391d7b13fe3535(formatted, 2).toLocaleString()).concat(suffix);
});
var $0a59e1cff196aa1f$exports = {};
$parcel$export($0a59e1cff196aa1f$exports, "formatYAxisPercent", function () {
  return $0a59e1cff196aa1f$export$f46f3370c2c30550;
});
var $0a59e1cff196aa1f$export$f46f3370c2c30550 = $parcel$interopDefault($cJ6Zc$lodash).memoize(function (v) {
  if (typeof v === 'string') return v;
  if (isNaN(v)) return '---';
  v *= 100;
  return "".concat($b7f4fcabf3442813$export$e5391d7b13fe3535(v, v < 1 ? 3 : 1), "%");
});
$parcel$exportWildcard(module.exports, $2b426f67b59e8726$exports);
$parcel$exportWildcard(module.exports, $c66c7baffc1c0dfc$exports);
$parcel$exportWildcard(module.exports, $2cb2128e0b9e1f2c$exports);
$parcel$exportWildcard(module.exports, $0a59e1cff196aa1f$exports);
$parcel$exportWildcard(module.exports, $ac7bd25d01e28e2d$exports);
$parcel$exportWildcard(module.exports, $b7f4fcabf3442813$exports);